import { endpoints, host } from '@config/endpoints';
import request from './request';
import Cookies from 'js-cookie';

export const exportISCO4 = async (HubIds: string[], ISICCodes: string[], ISCO2Codes: string[], ISCO4Codes: string[], Locations?: string[], fromQuarter?: string, toQuarter?: string, isco4Ranking?: number, isco4TotalCount?: number, isEntryLevel?: boolean) => {
    const { path, method } = endpoints.occupationAndSector.exportISCO4;

    let err = null;
    let res: any = null;
    let type = Cookies.get('darkMode') === "true" ? "dark" : "light";

    try {
        ({ data: res } = await request(
            `${host}${path}`,
            method,
            { HubIds, ISICCodes, ISCO2Codes, ISCO4Codes, Locations, fromQuarter, toQuarter, isco4Ranking, isco4TotalCount, isEntryLevel, type },
            {
                responseType: "blob"
            },
        ));
    } catch (error) {
        // @ts-ignore
        err = error.message;
    }

    return [err, res];
};
